module.exports = __webpack_public_path__ + "static/start-bg-370b0298eb4871a472106a288e92fd4c.svg";